<div class="product-card" data-cy="product-card">
    <div class="image-container">
        @if (image()) {
            <sirius-image-item
                [image]="image()!"
                [imageData]="imageData"
                [autocrop]="true" />
        }

        @if (attributes() && attributes().length) {
            <div class="attr">
                @for (attr of attributes(); track attr) {
                    <sirius-chip [config]="attr"></sirius-chip>
                }
            </div>
        }
    </div>

    <div class="content">
        <div class="text">
            @if (manufacturer()) {
                <span class="manufacturer" data-cy="product-manufacturer">
                    {{ manufacturer() }}
                </span>
            }

            <a [siriusLink]="link()" class="sir-card__link" (linkSelect)="onClick()">
                <h3 class="product-title sir-text-style-paragraph-m-bold" data-cy="product-name">{{ title() }}</h3>
            </a>
            <p class="teaser sir-text-style-paragraph-s-default" [innerHTML]="teaserHtml()"></p>
        </div>

        @if (tags() && tags().length > 0) {
            <div class="tags">
                @for (tag of tags(); track tag) {
                    <sirius-chip [config]="tag"></sirius-chip>
                }
            </div>
        }
    </div>
</div>
